import { PollAnswersProps } from './types';

export const PollAnswers = ({ children }: PollAnswersProps) => <div className="mt-5">{children}</div>;
